export const Props = () => ({
  //Напрвление перемотки
  isFoward: { type: Boolean }
});